/** Temporary pre-registry compatibility only. Active registries never use these URL conventions. */
export const HERA_CASSETTE_NATIVE_ZOOM_BY_URL = { '/tilesets/deposito2/': 14 };
export const HERA_ARCHAEOLOGICAL_NATIVE_ZOOM_BY_URL = { '/tilesets/paestum_map/': 21 };
export const HERA_MAINTENANCE_URL = 'https://dsz9uy9ks5t21.cloudfront.net/tilesets/archaeological2/{z}/{x}/{y}.png';
const HERA_DEPOT_URL = 'https://dsz9uy9ks5t21.cloudfront.net/tilesets/deposito2/{z}/{x}/{y}.png';

export function legacyHeraDepotUrls(value, background) {
    let urls;
    try { const parsed = JSON.parse(value); urls = (Array.isArray(parsed) ? parsed : [parsed]).filter(Boolean); }
    catch { urls = value ? [value] : []; }
    if (!urls.length) urls = [background].filter(Boolean);
    return urls.map(url => {
        try { return new URL(url).pathname.startsWith('/tilesets/deposito/') ? HERA_DEPOT_URL : url; }
        catch { return url; }
    });
}

export function legacyIsDepotDetail(url) {
    try { const path = new URL(url).pathname; return path.startsWith('/tilesets/deposito/') || path.startsWith('/tilesets/deposito2/'); }
    catch { return false; }
}

export function applyLegacyNativeZoom(layerGroups, mapping) {
    const entries = Object.entries(mapping ?? {});
    if (!entries.length) return layerGroups;
    return layerGroups.map(group => ({ ...group, layers: group.layers?.map(layer => {
        const match = entries.find(([fragment]) => layer.url?.includes(fragment));
        return match ? { ...layer, config: { ...layer.config, maxNativeZoom: match[1] } } : layer;
    }) }));
}
